module.exports = __webpack_public_path__ + "static/media/J8.826e7f0a.jpg";